import { Modal } from '@creditornot/cbt-modal';
import { Interval } from 'luxon/src/interval';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import FtuByVenueTable from './FtuByVenueTable';
import useFtuByVenueTableProps from './hooks/useFtuByVenueTableProps';
import { FtuByVenueTableSortableColumnIDs } from './types';
import { transformTableSortToApiSortBy } from './utils';
import useFtuByVenueInsights from '../../hooks/useFtuByVenueInsights';
import { InsightEntity, VenueEntity } from '../../types';
import LoadingView from '../LoadingView';
import { SortState } from '../tables/types';

type FtuByVenueModalProps = {
  onClose: () => void;
  insightEntity: Exclude<InsightEntity, VenueEntity>;
  dateInterval: Interval;
  isVATEnabled: boolean;
};

const FtuByVenueModal = ({ onClose, insightEntity, dateInterval, isVATEnabled }: FtuByVenueModalProps) => {
  const intl = useIntl();

  const [sort, setSort] = useState<SortState<FtuByVenueTableSortableColumnIDs> | undefined>(undefined);
  const ftuByVenueInsights = useFtuByVenueInsights({
    entityType: insightEntity.type,
    entityId: insightEntity.id,
    interval: dateInterval,
    sortBy: transformTableSortToApiSortBy(sort?.sortBy, isVATEnabled),
    sortOrder: sort?.sortOrder,
  });

  const tableProps = useFtuByVenueTableProps({ isVATEnabled, sort, setSort, ftuByVenueInsights, maxRows: undefined });

  return (
    <Modal
      open
      onDismiss={onClose}
      sizeConfig={{
        type: 'centered',
        width: '90vw',
        height: '90vh',
        maxHeight: '90%',
      }}
      disableContentPadding
      contentStyle={{ display: 'flex' }}
      title={intl.formatMessage({ id: 'insights.customer-base.table.customer-base-by-venue' })}
    >
      {ftuByVenueInsights.isLoading && ftuByVenueInsights.isFetching ? (
        <LoadingView />
      ) : (
        <FtuByVenueTable {...tableProps} />
      )}
    </Modal>
  );
};

export default FtuByVenueModal;
